import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ProjectSettingsPopup = loadAsyncComponent(() => import('./Container'), 'popup');
